/* Session action constants and shape */
import type {IWHISession} from '@nib/types-session-api';
import {Action} from '../../actions';
import {RecursivePartial} from '../../types';
import {FailedRequestPayload, AxiosError} from '../types';
import {RouteComponentProps} from '@reach/router';

const INIT_SESSION = 'session/init';
const FETCH_SESSION = 'session/fetch';
const UPDATE_SESSION = 'session/update';

// Action types to be used in actions
export const ActionTypes = {
  INIT_SESSION_PENDING: `${INIT_SESSION}_PENDING`,
  INIT_SESSION_FULFILLED: `${INIT_SESSION}_FULFILLED`,
  INIT_SESSION_REJECTED: `${INIT_SESSION}_REJECTED`,

  FETCH_SESSION_PENDING: `${FETCH_SESSION}_PENDING`,
  FETCH_SESSION_FULFILLED: `${FETCH_SESSION}_FULFILLED`,
  FETCH_SESSION_REJECTED: `${FETCH_SESSION}_REJECTED`,

  UPDATE_SESSION_PENDING: `${UPDATE_SESSION}_PENDING`,
  UPDATE_SESSION_FULFILLED: `${UPDATE_SESSION}_FULFILLED`,
  UPDATE_SESSION_REJECTED: `${UPDATE_SESSION}_REJECTED`
};

export interface ExcludedProps extends RouteComponentProps<{location: {state: {title: string}}}> {}

export interface SessionStatusState {
  loadingSession?: boolean;
  fetchedSession?: boolean;
  updatingSession?: boolean;
  sessionError?: AxiosError | null;
}

export interface SessionState extends SessionStatusState {
  session?: IWHISession;
}

// Payload definitions
export interface InitSessionPayload {
  queryString: string;
}

export interface InitSessionFulfilledPayload {
  session: IWHISession;
}

export interface FetchSessionPayload {
  sessionId: string;
}

export interface FetchSessionFulfilledPayload {
  session: IWHISession;
}

export interface UpdateSessionPayload {
  sessionId: string;
  session: IWHISession | RecursivePartial<IWHISession>;
}

export interface UpdateSessionFulfilledPayload {
  session: IWHISession;
}

// Action declerations
interface InitSessionAction extends Action<InitSessionPayload> {
  type: typeof ActionTypes.INIT_SESSION_PENDING;
  payload: InitSessionPayload;
}

interface InitSessionFulfilledAction extends Action<InitSessionFulfilledPayload> {
  type: typeof ActionTypes.INIT_SESSION_FULFILLED;
  payload: InitSessionFulfilledPayload;
}

interface InitSessionRejectedAction extends Action<object> {
  type: typeof ActionTypes.INIT_SESSION_REJECTED;
  payload: object; // @TODO
}

interface FetchSessionAction extends Action<FetchSessionPayload> {
  type: typeof ActionTypes.FETCH_SESSION_PENDING;
  payload: FetchSessionPayload;
}

interface FetchSessionFulfilledAction extends Action<FetchSessionFulfilledPayload> {
  type: typeof ActionTypes.FETCH_SESSION_FULFILLED;
  payload: FetchSessionFulfilledPayload;
}

interface FetchSessionRejectedAction extends Action<FailedRequestPayload> {
  type: typeof ActionTypes.FETCH_SESSION_REJECTED;
  payload: FailedRequestPayload;
}

interface UpdateSessionAction extends Action<UpdateSessionPayload> {
  type: typeof ActionTypes.UPDATE_SESSION_PENDING;
  payload: UpdateSessionPayload;
}

interface UpdateSessionFulfilledAction extends Action<UpdateSessionFulfilledPayload> {
  type: typeof ActionTypes.UPDATE_SESSION_FULFILLED;
  payload: UpdateSessionFulfilledPayload;
}

interface UpdateSessionRejectedAction extends Action<object> {
  type: typeof ActionTypes.UPDATE_SESSION_REJECTED;
  payload: FailedRequestPayload;
}

export type SessionActionTypes =
  | InitSessionAction
  | InitSessionFulfilledAction
  | InitSessionRejectedAction
  | FetchSessionAction
  | FetchSessionFulfilledAction
  | FetchSessionRejectedAction
  | UpdateSessionAction
  | UpdateSessionFulfilledAction
  | UpdateSessionRejectedAction;
